<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 10px;">
			<div :disabled="userRoleIdentity == 'level-untrue'" style="float:right;" >
				<el-switch @change="changeFilterDataTypeSwitch"  v-model="dataTypeSwitch" ></el-switch>
				<div  style="display:inline;padding-right:20px;font-size: 13px;">仅显示报警</div>
			</div>
			<el-tabs v-model="sysSourceOptName" @tab-click="tabHandleClick">
				<!-- <el-tab-pane label="全部" name="all"></el-tab-pane> -->
				<el-tab-pane v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-tab-pane>
			</el-tabs>
			<!-- <label v-if="sysSourceOptName == 'all'" style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">系统类型:</label>
			<el-select :disabled="userRoleIdentity == 'level-untrue'" v-if="sysSourceOptName == 'all'" v-model="sysSourceOpt" placeholder="全部" style="width: 140px">
				<el-option label="全部" value="all"></el-option>
				<el-option v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-option>
            </el-select> -->
			<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
			<el-input :disabled="userRoleIdentity == 'level-untrue'" placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 140px" @focus="showProjectTree" v-model="projectNames"></el-input>			
				<el-dialog :disabled="userRoleIdentity == 'level-untrue'" title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree" show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
			<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
			<div style="display:inline;">
				<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="startMonth" value-format="yyyyMM" format="yyyyMM" type="month" :placeholder="startMonthValue" @change="startMonthOnChange"></el-date-picker>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
				<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="endMonth" value-format="yyyyMM" format="yyyyMM" type="month" :placeholder="endMonthValue" @change="endMonthOnChange"></el-date-picker>
			</div>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" @click="queryBtn()">查询</el-button>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" @click="exportData()" style="float:right;">数据导出</el-button>
		</el-col>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="100" sortable>
			</el-table-column>
			<el-table-column prop="appSourceName" label="系统类型" width="120"  sortable>
			</el-table-column>
			<el-table-column v-if="sysSourceTabSelected =='BA' || sysSourceTabSelected =='FAS'" prop="deviceType" label="点名称" width="100" sortable>
			</el-table-column>
			<el-table-column v-else prop="deviceName" label="传感器名称" width="100" sortable>
			</el-table-column>
			<el-table-column v-if="sysSourceTabSelected =='BA' || sysSourceTabSelected =='FAS'" prop="deviceAddress" label="点地址" width="120" sortable>
			</el-table-column>
			<el-table-column v-else prop="deviceAddress" label="传感器地址" width="120" sortable>
			</el-table-column>
			<!-- <el-table-column prop="deviceType" label="设备类型" width="100" sortable>
			</el-table-column>
			<el-table-column prop="deviceAddress" label="设备地址" width="120" sortable>
			</el-table-column> -->
			<el-table-column prop="alarmContent" label="告警内容" min-width="160" sortable>
				<!-- <template slot-scope="scope">
                  <span v-if="scope.row.dataType=== '0'" style="color:#E30613;">{{scope.row.alarmContent}}</span>
                  <span v-if="scope.row.dataType=== '1'">{{scope.row.alarmContent}}</span>
	              </template> -->
			</el-table-column>
			<el-table-column prop="alarmTime" label="告警时间" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="finishTime" label="告警解除时间" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="dataTypeName" label="数据类型" min-width="100" sortable>
				<template slot-scope="scope">
                  <span v-if="scope.row.dataType===-1"  >{{scope.row.dataTypeName}}</span>
				  <span style="color:#E30613;" v-else>{{scope.row.dataTypeName}}</span>
	              </template>
			</el-table-column>
			<el-table-column prop="modifyUserName" label="归档人" min-width="100" sortable>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import global from '@/config/global_config'
	import Vue from 'vue'

	export default {
		data() {
			return {
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				sysSourceOptName:'',
				sysSourceList:[],
				sysSourceOpt:'',
				sysSourceTabSelected:'',
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectTreeCheckedKeys:[],
				startMonth: '',
				endMonth:'',
				startMonthValue:tools.getCurrentYear()+""+tools.getCurrentMonth()-1,
				endMonthValue:tools.getCurrentYear()+""+tools.getCurrentMonth(),
				projectIds:'',
                projectsOpt:[],
				projectNames:'',
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				filterDataTypeSwitch:null,
				dataTypeSwitch:0,
			}
		},
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		methods: {
			tabHandleClick(tab, event) {
				this.sysSourceTabSelected = this.sysSourceList[tab.index].code;
				this.get_list_data()
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			 filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
            },
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					let checkedTemp =[];
					 for (let index = 0; index < res.data.length; index++) {
						checkedTemp.push(res.data[index].groupId);
						temp[index] = {id:res.data[index].groupId ,label:res.data[index].groupName,children:[]};
						res.data[index].projectList.forEach(one => {
							checkedTemp.push(one.projectId);
							temp[index].children.push({id:one.projectId,label:one.projectName});
						});
					}
					console.log(temp);
					this.projectTree = temp;
					//this.projectTreeDefaultChecked = checkedTemp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					console.log(leafCheckedNodeNames);
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			startMonthOnChange(val) {  
				console.log(val);  
				this.startMonthValue = val;  
			},
			endMonthOnChange(val) {  
				this.endMonthValue = val;
            },
            queryBtn(){
				if(!this.startMonthValue){tools.error(this,'请选择开始月份');return false};
				if(!this.endMonthValue){tools.error(this,'请选择结束月份');return false};
				this.get_list_data();
			},
			get_list_data() {
				if((!tools.strIsEmpty(this.startMonthValue))&&(!tools.strIsEmpty(this.endMonthValue))){
					console.log(typeof(this.startMonthValue));
					var starttime = Date.parse(new Date(this.startMonthValue.toString().substr(0,4),this.startMonthValue.toString().substr(4,2)));
					var endtime = Date.parse(new Date(this.endMonthValue.toString().substr(0,4),this.endMonthValue.toString().substr(4,2)));
					if(starttime>endtime){
						tools.error(new Vue(),"开始时间不能比结束时间大");
						return;
					}
					if((endtime - starttime) > 31536000000){
						tools.error(new Vue(),"暂不支持超过一年范围的查询");
						return;
					}
				}
				if(this.sysSourceOpt == 'all') this.sysSourceOpt = '';
				let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				let param = {
					pageNum: this.page,
					appSourceCodes:appSourceCodes,
					projectIds:this.projectIds,
					pageSize:15,
					startYm:this.startMonthValue,
					endYm:this.endMonthValue
				};
				if(null != this.filterDataTypeSwitch) param.dataType = this.filterDataTypeSwitch;
				this.listLoading = true;
				api.historyAlarm_list_request(param).then((res) => {
					this.total = res.data.total;
					if (res.data.list) {
						res.data.list.forEach(one => {
							// if(one.dataType == '0'){
							// 	one.dataType = '告警';
							// }
							// else if(one.dataType == '1'){
							// 	one.dataType = '常规';
							// }
						});
					}
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
                    tools.error(new Vue(),e.message);
				});
			},
			updateAlarmState: function (index, row) {
				let param = {
					ids: row.id,
				};
				this.listLoading = true;
				api.currentAlarm_updateAlarmState_request(param).then((res) => {
					tools.success(this,"归档成功");
					this.get_list_data();				
				}).catch((e) => {
					console.log(e);
                    tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			getSysSourceList: function () {
				let param = {};
				this.listLoading = true;
				api.system_getSysSourceList_request(param).then((res) => {
					this.sysSourceList = res.data;
					this.sysSourceTabSelected = this.sysSourceList[0].code;	
					this.get_list_data();	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			exportData:function () {
				let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				let param = {
					appSourceCodes:appSourceCodes,
					projectIds:this.projectIds,
					startYm:this.startMonthValue,
					endYm:this.endMonthValue
				};
				this.listLoading = true;
				api.historyAlarm_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'historyAlarmList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
                    tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			changeFilterDataTypeSwitch: function (newStatus) {
				console.log(newStatus);
				status = Number(newStatus);
				if(status == 0)this.filterDataTypeSwitch =null;
				else if(status == 1)this.filterDataTypeSwitch =0;
				this.get_list_data();
			}
		},
		mounted() {
			this.getSysSourceList();
			this.getProjectTree();
		}
	}

</script>


// WEBPACK FOOTER //
// history_alarm_list.vue?2ccaff42